import { ACTIVE_EXPERIMENTS } from '$lib/services/experiments/client/constants';
import { experimentService } from '$lib/services/experiments/client';
import { ProductExperienceService } from '$lib/services/product-experience';
import { AOFL_PRODUCT_NAMES } from '$lib/utils/constants';

/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	// In-app users should always be shown the in-app experience (and it should be the 1.0 version)
	inApp: {
		condition: async (config) => {
			return config.meta.inApp;
		},
		resolve: async () => {
			await ProductExperienceService.setProductExperience(AOFL_PRODUCT_NAMES.ABCMOUSE);
			return await import('../_in-app/Page.svelte');
		},
	},
	browser_2_0_mini_reg_nmhp: {
		condition: async () => {
			const isNmhpMiniRegExperimentActive = await experimentService.isAnyExperimentArmActive(
				ACTIVE_EXPERIMENTS.ABCM2_MINI_REG_NMHP.experimentKey,
				[ACTIVE_EXPERIMENTS.ABCM2_MINI_REG_NMHP.variants.test],
				{
					page_name: 'home',
					page_url: '/abc',
				}
			);
			return isNmhpMiniRegExperimentActive;
		},
		resolve: async () => await import('../_browser-2-0-rebrand-mini-reg/Page.svelte'),
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser-2-0-rebrand/Page.svelte'),
	},
};

export { pageConditions };
